import { Button } from '@acpaas-ui/react-components';
import { useForm } from '../../../hooks/useForm.hook';
import casetafelsService from '../../../services/api/casetafels.service';
import permissionsService from '../../../services/permissions/permissions.service';
import Accordion from '../../core/accordion/Accordion';
import AccordionTab from '../../core/accordion/AccordionTab';
import AccordionTabContent from '../../core/accordion/AccordionTabContent';
import AccordionTabHeader from '../../core/accordion/AccordionTabHeader';
import FormPicker from './FormPicker';
import QuestionnaireContent from './QuestionnaireContent';

const DossierCasetafelQuestionnaire = ({
  id,
  dossierId,
  onUpdated,
  onAnswered,
  onAnswersExport,
  formSlug,
  formOptions = [],
  answers = [],
  involved = [],
  user,
  isRepresentative,
  isExportingAnswers,
  read,
  readReportOnly,
  write,
  writeApproveAndQuestionnaireOnly
}) => {
  const { isSubmitting, data, reset, input, submitStart, submitOk, submitError } = useForm({
    id,
    formSlug
  });
  const resource = {
    isFetching: false,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options = {}) => {
      submitStart();
      casetafelsService.update(
        dossierId,
        data?.id,
        { [field]: value },
        {
          onSuccess: () => {
            submitOk();
            input(value, field);
            onUpdated(value, field, data?.id);
            options?.onSuccess?.();
          },
          onError: (message) => {
            submitError({ [field]: message });
            options?.onError?.(message);
          }
        }
      );
    },
    onCancel: reset
  };

  const shouldOpenQuestionnaireForm = () => {
    return !!localStorage.getItem('recoverForm');
  };

  if (!read || (readReportOnly && !writeApproveAndQuestionnaireOnly)) {
    return null;
  }

  if (!write && !writeApproveAndQuestionnaireOnly) {
    return null;
  }

  return (
    <div className="spo-o-dossier-casetafel-questionnaire u-margin-bottom-lg">
      <Accordion>
        <AccordionTab headerClass="casetafel-questionnaire" open={shouldOpenQuestionnaireForm()}>
          <AccordionTabHeader className="casetafel-questionnaire">
            Voorbereidingsformulier
            {permissionsService.canExportCasetafelAnswers(user, involved, answers) && (
              <Button
                className="u-margin-left-auto"
                size="tiny"
                outline
                iconRight="ai-download-bottom"
                disabled={isExportingAnswers}
                onClick={() => onAnswersExport(id)}
              >
                Exporteer
              </Button>
            )}
          </AccordionTabHeader>
          <AccordionTabContent>
            <div className="spo-o-dossier-casetafel-questionnaire__content">
              <FormPicker
                isRepresentative={isRepresentative}
                formOptions={formOptions}
                isSubmitting={isSubmitting}
                disabled={answers?.length > 0 || isSubmitting}
                onChange={(value) => input(value, 'formSlug')}
                onClose={(value) => {
                  if (value !== data?.formSlug) {
                    resource.setValue(value, 'formSlug');
                  }
                }}
                data={data}
              />
              <div className="u-padding">
                <QuestionnaireContent
                  write={write || writeApproveAndQuestionnaireOnly}
                  data={data}
                  dossierId={dossierId}
                  caseTableId={id}
                  isRepresentative={isRepresentative}
                  answers={answers}
                  user={user}
                  onAnswered={onAnswered}
                  formSchema={formOptions?.find((form) => form.value === formSlug)?.meta ?? {}}
                />
              </div>
            </div>
          </AccordionTabContent>
        </AccordionTab>
      </Accordion>
    </div>
  );
};

export default DossierCasetafelQuestionnaire;
